export default __webpack_public_path__ + "static/media/BM.21b18520.svg";